// @flow
import { all, fork, put, takeLatest, call } from 'redux-saga/effects';

import { processTrackingRecords as processTrackingRecordsApi } from '../../helpers/';
import { getAllShipments as getAllShipmentsAction } from '../shipments/actions';
import { addToast } from '../actions';
import { shipmentTrackingRecordsApiResponseSuccess, shipmentTrackingRecordsApiResponseError } from './actions';
import { ShipmentTrackingRecordsActionTypes } from './constants';

function* processTrackingRecords({ payload: { query } }) {
    try {
        const response = yield call(processTrackingRecordsApi, query);
        const triggered = response?.data?.triggered_tracking_records ?? response?.data?.tracking_records_count ?? 0;

        yield put(shipmentTrackingRecordsApiResponseSuccess(ShipmentTrackingRecordsActionTypes.PROCESS_TRACKING_RECORDS, response.data));
        const desc =
            triggered === 0
                ? 'No tracking records matched the selected filters to process.'
                : `Processing triggered for ${triggered} tracking record${triggered === 1 ? '' : 's'}.`;
        const type = triggered === 0 ? 'info' : 'success';
        yield put(
            addToast({
                desc,
                type,
            })
        );

        if (query) {
            yield put(getAllShipmentsAction(query));
        }
    } catch (error) {
        const message = error?.errors?.[0]?.message || 'Unable to process shipment tracking records';
        yield put(addToast({ desc: message, type: 'error' }));
        yield put(shipmentTrackingRecordsApiResponseError(ShipmentTrackingRecordsActionTypes.PROCESS_TRACKING_RECORDS, error));
    }
}

export function* watchProcessTrackingRecords(): any {
    yield takeLatest(ShipmentTrackingRecordsActionTypes.PROCESS_TRACKING_RECORDS, processTrackingRecords);
}

function* shipmentTrackingRecordsSaga(): any {
    yield all([fork(watchProcessTrackingRecords)]);
}

export default shipmentTrackingRecordsSaga;
